import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { useBrandingStore } from '../store/brandingStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuth, isLoading } = useAuthStore();
  const location = useLocation();
  const { getPrimaryColor } = useBrandingStore();
  const primary = getPrimaryColor();

  // Если загружается или нет токена - показываем загрузку
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div
          className="animate-spin rounded-full h-12 w-12 border-b-2"
          style={{
            borderTopColor: 'transparent',
            borderRightColor: primary,
            borderBottomColor: primary,
            borderLeftColor: primary
          }}
        ></div>
      </div>
    );
  }

  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 